import { FunctionComponent, useEffect, useState } from 'react'
import { Alert } from 'react-bootstrap'

import AuthCardLayout from 'components/layout/auth/authCardLayout'
import * as api from '../api.client'
import { AppMessage } from '../../../utilities/messages'
import { useNavigate, useParams } from 'react-router-dom'
import { PasswordResetInfo } from '../types'
import NewPasswordForm from '../shared/newPasswordForm'

const CreatePassword: FunctionComponent = () => {
  const navigate = useNavigate()
  const { token } = useParams<{ token: string }>()
  const [showFormErrors, setShowFormErrors] = useState(false)
  const [appMessage, setAppMessage] = useState<AppMessage>({ show: false })
  const [creatingPassword, setCreatingPassword] = useState(false)
  const [updatedCredentials, setUpdatedCredentials] =
    useState<PasswordResetInfo>({
      token: token as string,
      password: '',
      passwordConfirmation: '',
    })

  useEffect(() => {
    if (!token) {
      setAppMessage({
        show: true,
        success: false,
        message:
          'O token necessário para redefinir a senha não foi encontrado.',
      })
    }
  }, [token])

  const createPassword = async (event: React.ChangeEvent<HTMLFormElement>) => {
    event.preventDefault()

    const formIsValid = event.currentTarget.checkValidity()

    if (!formIsValid) {
      setShowFormErrors(true)
      return
    }

    setCreatingPassword(true)

    try {
      const { email } = await api.createPassword(updatedCredentials)
      navigate('/login', {
        state: { message: 'Senha criada com sucesso.', email },
      })
    } catch (error) {
      setAppMessage({
        show: true,
        success: false,
        message: (error as any).messages.join(', '),
      })
    } finally {
      setCreatingPassword(false)
    }
  }

  const handleFormChange = ({
    target,
  }: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = target

    setUpdatedCredentials({ ...updatedCredentials, [name]: value })
  }

  return (
    <AuthCardLayout
      badge="Convite do hospital"
      title="Crie sua senha de acesso"
      subtitle="Você foi convidado a acompanhar seus repasses no Clic-repasse."
    >
      {appMessage.show && (
        <Alert variant={appMessage.success ? 'success' : 'danger'}>
          {appMessage.message}
        </Alert>
      )}
      <NewPasswordForm
        values={updatedCredentials}
        onChange={handleFormChange}
        onSubmit={createPassword}
        validated={showFormErrors}
        submitting={creatingPassword}
        disabled={!token}
        submitLabel="Criar senha"
        passwordLabel="Senha"
        confirmationLabel="Confirmar senha"
      />
    </AuthCardLayout>
  )
}

export default CreatePassword
